export default __webpack_public_path__ + "static/media/freezer-hero-01.4ea7dd1c.svg";